// src/pages/fiscal/mdfe/CondutorCad.js
import React from 'react';
import { Condutor } from '../../../models/fiscal/Condutor';
import CadastroFiscalCad from './CadastroFiscalCad';

const campos = [
  { nome: 'nome', label: 'Nome', size: 300 },
  { nome: 'cpf', label: 'CPF', size: 160, mask: '999.999.999-99' },
  { nome: 'ativo', label: 'Ativo', tipo: 'check' },
];
const CondutorCad = (props) => <CadastroFiscalCad {...props} tipo="condutores" titulo="Condutor" Model={Condutor} campos={campos} />;
export default CondutorCad;
